import React from 'react'
import { CustomInput } from 'reactstrap'

export default ({ value, ...rest }) => (
  <CustomInput type="switch" checked={value} {...rest} />
)
